import { SearchResult, SearchResultWithTitleAndUrl } from '@lumapps/search/types';

/** Makes sure that the given search result has a title and url field */
export const resultHasTitleAndUrl = (result: Partial<SearchResult>): result is SearchResultWithTitleAndUrl =>
    'title' in result && 'url' in result;
